import { updateUserOptions } from '../actions/updateUserOptions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { EditorServiceModels } from '@editor/client-rest-api';

export const updateUserOptionsMutator = mutator(updateUserOptions, actionMessage => {
    const { userOptions } = getStore();
    const newOptions = actionMessage.options;
    getStore().userOptions = { ...userOptions, ...newOptions };

    if (newOptions.overriddenOptions) {
        getStore().userOptions.overriddenOptions = new ObservableMap<
            string,
            EditorServiceModels.CritiqueTypeOption
        >(newOptions.overriddenOptions);
    }

    if (newOptions.overriddenCategories) {
        getStore().userOptions.overriddenCategories = new ObservableMap<string, boolean>(
            newOptions.overriddenCategories
        );
    }
});
